function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }

var n = "function",
    t = "string",
    e = "undefined",
    r = "boolean",
    o = "object",
    u = "array",
    c = "number",
    i = "symbol",
    a = "null",
    f = "error",
    s = "typeError",
    l = "syntaxError",
    p = "asyncFunction",
    d = "generatorFunction",
    y = "asyncGeneratorFunction",
    g = function g() {},
    m = "any",
    v = "*",
    b = "none",
    h = "hidden",
    O = "__",
    S = "form",
    j = "input",
    A = "button",
    E = "select",
    N = "change",
    w = "submit",
    D = /^\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d\.\d+([+-][0-2]\d:[0-5]\d|Z)$/,
    z = /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/,
    Z = /^\{[\s\S]*\}$|^\[[\s\S]*\]$/,
    P = (typeof process === "undefined" ? "undefined" : _typeof(process)) !== e ? process : {},
    x = P.env && P.env.NODE_ENV || "",
    C = "production" === x,
    F = "staging" === x,
    L = "development" === x,
    $ = (typeof document === "undefined" ? "undefined" : _typeof(document)) !== e,
    T = $ && "localhost" === window.location.hostname,
    _ = null != P.versions && null != P.versions.node,
    k = (typeof Deno === "undefined" ? "undefined" : _typeof(Deno)) !== e && _typeof(Deno.core) !== e,
    B = (typeof self === "undefined" ? "undefined" : _typeof(self)) === o && self.constructor && "DedicatedWorkerGlobalScope" === self.constructor.name,
    G = $ && "nodejs" === window.name || (typeof navigator === "undefined" ? "undefined" : _typeof(navigator)) !== e && _typeof(navigator.userAgent) !== e && (navigator.userAgent.includes("Node.js") || navigator.userAgent.includes("jsdom"));

function M(n, t) {
  return t.charAt(0)[n]() + t.slice(1);
}

var U = M.bind(null, "toUpperCase"),
    H = M.bind(null, "toLowerCase");

function J(n) {
  return Y(n) ? U(a) : _typeof(n) === o ? yn(n) : Object.prototype.toString.call(n).slice(8, -1);
}

function R(n, t) {
  void 0 === t && (t = !0);
  var e = J(n);
  return t ? H(e) : e;
}

function V(n, t) {
  return _typeof(t) === n;
}

var W = V.bind(null, n),
    q = V.bind(null, t),
    I = V.bind(null, e);

function K(n) {
  return !I(n);
}

var Q = V.bind(null, r),
    X = V.bind(null, i);

function Y(n) {
  return null === n;
}

function nn(n) {
  return R(n) === c && !isNaN(n);
}

function tn(n) {
  return !isNaN(parseFloat(n));
}

function en(n) {
  return !!W(n) && /^class /.test(Function.prototype.toString.call(n));
}

function rn(n) {
  return R(n) === u;
}

function on(n) {
  if (!un(n)) return !1;

  for (var t = n; null !== Object.getPrototypeOf(t);) {
    t = Object.getPrototypeOf(t);
  }

  return Object.getPrototypeOf(n) === t;
}

function un(n) {
  return n && (_typeof(n) === o || null !== n);
}

function cn(n) {
  if (!q(n) || !Z.test(n)) return !1;

  try {
    JSON.parse(n);
  } catch (n) {
    return !1;
  }

  return !0;
}

function an(n) {
  if (Y(n)) return !0;

  switch (_typeof(n)) {
    case t:
    case c:
    case i:
    case e:
    case r:
      return !0;

    default:
      return !1;
  }
}

function fn(n, t) {
  return on(n) && W(n[t]);
}

function sn(n) {
  return !!n && !!(!I(Promise) && n instanceof Promise || n.then && W(n.then));
}

function ln(n) {
  return un(n) && W(n["throw"]) && W(n["return"]) && W(n.next);
}

function pn(n) {
  return R(n) === d;
}

function dn(n) {
  return R(n) === p;
}

function yn(n) {
  return W(n.constructor) ? n.constructor.name : null;
}

function gn(n) {
  return n instanceof Set;
}

function mn(n) {
  return n instanceof Map;
}

function vn(n) {
  return n instanceof RegExp;
}

function bn(n) {
  return !(!n.constructor || !W(n.constructor.isBuffer)) && n.constructor.isBuffer(n);
}

function hn(n) {
  return n instanceof Error || q(n.message) && n.constructor && nn(n.constructor.stackTraceLimit);
}

function On(n) {
  return un(n) && q(n.message) && q(n.name);
}

function Sn(n, t) {
  if ("object" != _typeof(t) || Y(t)) return !1;
  if (t instanceof n) return !0;
  var e = R(new n(""));
  if (hn(t)) for (; t;) {
    if (R(t) === e) return !0;
    t = Object.getPrototypeOf(t);
  }
  return !1;
}

var jn = Sn.bind(null, TypeError),
    An = Sn.bind(null, SyntaxError);

function En(n) {
  if (!W(n)) return !1;
  var t = /{(\r|\n|\s)*}/gm,
      e = g + "";
  return e === (n.toString().match(t) || [""])[0].replace(t, e);
}

function Nn(n) {
  try {
    if (nn(n.length) && W(n.callee)) return !0;
  } catch (n) {
    if (-1 !== n.message.indexOf("callee")) return !0;
  }

  return !1;
}

function wn(n) {
  return !(q(n) && "false" === n.toLowerCase() || !n);
}

function Dn(n) {
  return !n;
}

function zn(n) {
  return !0 === n;
}

function Zn(n) {
  return !1 === n;
}

function Pn(n) {
  return !(n.length > 320) && z.test(n);
}

function xn(n) {
  return n instanceof Date || W(n.toDateString) && W(n.getDate) && W(n.setDate);
}

function Cn(n) {
  return D.test(n);
}

function Fn(n) {
  return !(!Y(n) && (rn(n) ? n.length : gn(n) || mn(n) ? n.size : on(n) && Object.keys(n).length));
}

function Ln(n) {
  return NodeList.prototype.isPrototypeOf(n);
}

function $n(n, t) {
  var e = n instanceof Element || n instanceof HTMLDocument;
  return e && t ? Tn(n, t) : e;
}

function Tn(n, t) {
  return void 0 === t && (t = ""), n && n.nodeName === t.toUpperCase();
}

function _n(n) {
  var t = [].slice.call(arguments, 1);
  return function () {
    return n.apply(void 0, [].slice.call(arguments).concat(t));
  };
}

var kn = _n($n, S),
    Bn = _n($n, A),
    Gn = _n($n, j),
    Mn = _n($n, E);

function Un(n, t) {
  if (!n || getComputedStyle(n).visibility === h) return !0;

  for (; n;) {
    if (null != t && n === t) return !1;
    if (getComputedStyle(n).display === b) return !0;
    n = n.parentElement;
  }

  return !1;
}

function Hn(n) {
  return n ? rn(n) ? n : [n] : [];
}

export { v as ALL, m as ANY, u as ARRAY, p as ASYNC_FUNCTION, y as ASYNC_GENERATOR_FUNCTION, r as BOOLEAN, A as BUTTON, N as CHANGE, x as ENV, f as ERROR, S as FORM, n as FUNCTION, d as GENERATOR_FUNCTION, h as HIDDEN, j as INPUT, b as NONE, a as NULL, c as NUMBER, o as OBJECT, O as PREFIX, z as REGEX_EMAIL, D as REGEX_ISO, Z as REGEX_JSON, E as SELECT, t as STRING, w as SUBMIT, i as SYMBOL, l as SYNTAX_ERROR, s as TYPE_ERROR, e as UNDEFINED, yn as ctorName, Hn as ensureArray, R as getType, J as getTypeName, Nn as isArguments, rn as isArray, dn as isAsyncFunction, Q as isBoolean, $ as isBrowser, bn as isBuffer, Bn as isButton, en as isClass, xn as isDate, K as isDefined, k as isDeno, L as isDev, $n as isElement, Pn as isEmail, Fn as isEmpty, hn as isError, On as isErrorLike, Zn as isFalse, Dn as isFalsy, kn as isForm, W as isFunction, ln as isGenerator, pn as isGeneratorFunction, Un as isHidden, Gn as isInput, Cn as isIsoDate, G as isJsDom, cn as isJson, T as isLocalHost, mn as isMap, fn as isMethod, En as isNoOp, _ as isNode, Ln as isNodeList, Tn as isNodeType, Y as isNull, nn as isNumber, tn as isNumberLike, on as isObject, un as isObjectLike, an as isPrimitive, C as isProd, sn as isPromise, vn as isRegex, Mn as isSelect, gn as isSet, F as isStaging, q as isString, X as isSymbol, An as isSyntaxError, zn as isTrue, wn as isTruthy, jn as isTypeError, I as isUndefined, B as isWebWorker, g as noOp };